import "./style.css";

function SettingsCard({ children, className = "" }) {
  return <div className={`aris-settings-card ${className}`.trim()}>{children}</div>;
}

export default SettingsCard;
